"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectPaymentsCustomerState = void 0;
var DirectPaymentsCustomerState;
(function (DirectPaymentsCustomerState) {
    DirectPaymentsCustomerState["NEW"] = "new";
    DirectPaymentsCustomerState["RETURNING"] = "returning";
})(DirectPaymentsCustomerState = exports.DirectPaymentsCustomerState || (exports.DirectPaymentsCustomerState = {}));
